// extracted by mini-css-extract-plugin
export default {"backDrop":"Loader_backDrop__DGfp5","loader":"Loader_loader__pQgLe"};